import 'ui-core/plugins/truncate/js/init';

(function () {
    UX.truncateInit = {
        vPort: 'screen-sm',
        isMobile: false,
        init: function () {
            UX.truncateInit.control();
            $('.creative-work__title').not("[data-truncate='none']").truncate({
                lines: 2,
                addClass: 'min-height',
            });
            $('.creative-work .loa').not("[data-truncate='none']").truncate({
                lines: 2,
                type: 'list',
                addClass: 'loa-height',
            });

            $('.featured .grid-item:first-child .creative-work__title').not("[data-truncate='none']").truncate({
                lines: 2,
                addClass: 'min-height',
            });

            $('.card .creative-work__title').not("[data-truncate='none']").truncate({
                lines: 2,
                addClass: 'min-height',
            });

            $('.card .creative-work .loa').not("[data-truncate='none']").truncate({
                lines: 1,
                type: 'list',
                addClass: 'loa-height',
            });

            $(window).on('resized orientationchange', function () {
                $('.creative-work__title, .creative-work .loa').not("[data-truncate='none']").truncate();
            });
        },
        truncatX: function () {
            const truncateTarget = $('.creative-work__title').not("[data-truncate='none']");
            if (UX.truncateInit.isMobile) {
                truncateTarget.truncate({
                    lines: 3,
                    addClass: 'min-height',
                });
            } else {
                truncateTarget.truncate({
                    lines: 2,
                    addClass: 'min-height',
                });
            }
        },
        control: function () {
            $(document).on(UX.truncateInit.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                UX.truncateInit.isMobile = true;
                UX.truncateInit.truncatX();
            });

            $(document).on(UX.truncateInit.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                UX.truncateInit.isMobile = false;
                UX.truncateInit.truncatX();
            });
        },
    };
})();
